import React from "react";
import styled from "@emotion/styled";
import { useTheme } from "@emotion/react";

const ChecktBoxInput = styled.button<{ checked: boolean }>(
  ({ theme, checked }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1.6rem",
    fontSize: "1.6rem",
    lineHeight: "1.6rem",
    border: checked
      ? `1px solid ${theme.color.mint}`
      : `1px solid ${theme.color.light_gray}`,
    backgroundColor: checked ? theme.color.light_mint : "transparent",
  }),
);

type Props = {
  label: string;
  checked: boolean;
  onClick: () => void;
};
const CheckBoxInput = ({ label, checked, onClick }: Props) => {
  const theme = useTheme();

  return (
    <ChecktBoxInput checked={checked} onClick={onClick} type="button">
      <span>{label}</span>

      {checked ? (
        <img alt="icon" src={theme.image.check_mint.default} />
      ) : (
        <img alt="icon" src={theme.image.check_gray.default} />
      )}
    </ChecktBoxInput>
  );
};

export default CheckBoxInput;
